import { h, Component, createRef } from 'preact'
import cn from 'classnames'
import { showCircle } from './circle'
import s from './Bubble.css'

interface iProps {
  tag: string
  center: boolean
  className?: string
  color?: 'blue'
}

export class Bubble extends Component<iProps> {
  static defaultProps = {
    tag: 'span',
    center: false
  }

  ref = createRef<HTMLSpanElement>()

  onClick = (e: MouseEvent) => {
    e.stopPropagation()
    const { center } = this.props
    const { current: bubble } = this.ref

    if (bubble) {
      showCircle(bubble, e, { center })
    }
  }

  render () {
    const {
      tag,
      className,
      color,
      children,
      ...restProps
    } = this.props

    const props = {
      className: cn(
        s.Bubble,
        {
          [s.Bubble_blue]: color === 'blue'
        },
        className
      ),
      ref: this.ref,
      onMouseDown: this.onClick,
      ...restProps
    }

    return h(tag, props, children)
  }
}

export default Bubble
